<div class="container mt-4" style="min-height: clac(100vh - 300px)">
<form [formGroup]="expenditureForm" (ngSubmit)="onSubmit()">
  <div class="row">

    <div class="col-lg-12">
      <h4 class="font-medium election-title">📊 State Development Budget and Expenditure</h4>
    </div>

    <!-- Radio Buttons -->
    <div class="col-lg-3 col-md-6 mb-3">
      <label class="form-label m-0">Choose<sup class="text-danger">*</sup></label>
      <div class="row">
        <div class="col-6 form-check" *ngIf="showCircle">
          <input class="form-check-input" type="radio" formControlName="type" [value]="1"
            id="StateDevlopBudgetExpenditure1" >
          <label class="form-check-label" for="StateDevlopBudgetExpenditure1">Circle</label>
        </div>
        <div class="col-6 form-check" *ngIf="showTribal">
          <input class="form-check-input" type="radio" formControlName="type" [value]="2"
            id="StateDevlopBudgetExpenditure2">
          <label class="form-check-label" for="StateDevlopBudgetExpenditure2">Tribal</label>
        </div>
      </div>
      <div *ngIf="expenditureForm.get('type')?.touched && expenditureForm.get('type')?.invalid"
        class="text-danger small">
        Please select type.
      </div>
    </div>

    <!-- Tribal Area -->
    <div class="col-lg-3 col-md-6 mb-3" *ngIf="expenditureForm.get('type')?.value == 2">
      <label class="form-label m-0">Tribal Area<sup class="text-danger">*</sup></label>
      <select class="form-control" formControlName="tribalArea">
        <option value="" disabled selected>- -Select- -</option>
        <option *ngFor="let item of tribalData" [value]="item?.id">
          {{ item?.tribalArea }}
        </option>
      </select>
      <div *ngIf="expenditureForm.get('tribalArea')?.touched && expenditureForm.get('tribalArea')?.invalid"
        class="text-danger small">
        Please select tribal area.
      </div>
    </div>

    <div class="d-flex align-items-center justify-content-between mb-3">
      <h5 class="font-medium m-0">📄Report</h5>
      <button type="button" class="btn btn-primary btn-sm" data-bs-toggle="modal" (click)="goToReportPage()">Back To
        Report Page </button>
    </div>

    <!-- Tribal Start -->
    <div class="col-lg-12">
      <div class="row" *ngIf="expenditureForm.get('type')?.value == 1">

        <!-- SOE-44 -->
        <div class="col-lg-6">
          <div class="card">
            <div class="card-header">
              <h5 class="font-medium m-0">📄 2408-01-796-02 SOON SOE-44</h5>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-6 mb-3">
                  <label class="form-label m-0">Budget<sup class="text-danger">*</sup></label>
                  <input type="text" formControlName="t44Budget" class="form-control"
                    placeholder="Please Enter" maxlength="10" (keypress)="onlyNumbers($event)">
                  <div *ngIf="expenditureForm.get('t44Budget')?.touched && expenditureForm.get('t44Budget')?.invalid"
                    class="text-danger small">
                    This field is required.
                  </div>
                </div>
                <div class="col-md-6 mb-3">
                  <label class="form-label m-0">Expenditure<sup class="text-danger">*</sup></label>
                  <input type="text" formControlName="t44Amount" class="form-control"
                    placeholder="Please Enter" maxlength="10" (keypress)="onlyNumbers($event)">
                  <div *ngIf="expenditureForm.get('t44Amount')?.touched && expenditureForm.get('t44Amount')?.invalid"
                    class="text-danger small">
                    This field is required.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- SOE-42 -->
        <div class="col-lg-6">
          <div class="card">
            <div class="card-header">
              <h5 class="font-medium m-0">📄 2408-01-796-03 SOON SOE-42</h5>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-6 mb-3">
                  <label class="form-label m-0">Budget<sup class="text-danger">*</sup></label>
                  <input type="text" formControlName="t42Budget" class="form-control"
                    placeholder="Please Enter" maxlength="10" (keypress)="onlyNumbers($event)">
                  <div *ngIf="expenditureForm.get('t42Budget')?.touched && expenditureForm.get('t42Budget')?.invalid"
                    class="text-danger small">
                    This field is required.
                  </div>
                </div>
                <div class="col-md-6 mb-3">
                  <label class="form-label m-0">Expenditure<sup class="text-danger">*</sup></label>
                  <input type="text" formControlName="t42Amount" class="form-control"
                    placeholder="Please Enter" maxlength="10" (keypress)="onlyNumbers($event)">
                  <div *ngIf="expenditureForm.get('t42Amount')?.touched && expenditureForm.get('t42Amount')?.invalid"
                    class="text-danger small">
                    This field is required.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- SOE-41 -->
        <div class="col-lg-6">
          <div class="card">
            <div class="card-header">
              <h5 class="font-medium m-0">📄 2425-00-796-03 SOON SOE-41</h5>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-6 mb-3">
                  <label class="form-label m-0">Budget<sup class="text-danger">*</sup></label>
                  <input type="text" formControlName="t41Budget" class="form-control"
                    placeholder="Please Enter" maxlength="10" (keypress)="onlyNumbers($event)">
                  <div *ngIf="expenditureForm.get('t41Budget')?.touched && expenditureForm.get('t41Budget')?.invalid"
                    class="text-danger small">
                    This field is required.
                  </div>
                </div>
                <div class="col-md-6 mb-3">
                  <label class="form-label m-0">Expenditure<sup class="text-danger">*</sup></label>
                  <input type="text" formControlName="t41Amount" class="form-control"
                    placeholder="Please Enter" maxlength="10" (keypress)="onlyNumbers($event)">
                  <div *ngIf="expenditureForm.get('t41Amount')?.touched && expenditureForm.get('t41Amount')?.invalid"
                    class="text-danger small">
                    This field is required.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Tribal Overall -->
        <div class="col-lg-6">
          <div class="card">
            <div class="card-header">
              <h5 class="font-medium m-0">📄 Overall</h5>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-6 mb-3">
                  <label class="form-label m-0">Total Budget<sup class="text-danger">*</sup></label>
                  <input type="text" formControlName="tOverALLBudget" class="form-control"
                    placeholder="Please Enter" maxlength="10" (keypress)="onlyNumbers($event)">
                  <div
                    *ngIf="expenditureForm.get('tOverALLBudget')?.touched && expenditureForm.get('tOverALLBudget')?.invalid"
                    class="text-danger small">
                    This field is required.
                  </div>
                </div>
                <div class="col-md-6 mb-3">
                  <label class="form-label m-0">Total Expenditure<sup class="text-danger">*</sup></label>
                  <input type="text" formControlName="tOverALLAmount" class="form-control"
                    placeholder="Please Enter" maxlength="10" (keypress)="onlyNumbers($event)">
                  <div
                    *ngIf="expenditureForm.get('tOverALLAmount')?.touched && expenditureForm.get('tOverALLAmount')?.invalid"
                    class="text-danger small">
                    This field is required.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <!-- Circle Section -->
    <div class="col-lg-12">
      <div class="row" *ngIf="expenditureForm.get('type')?.value == 2">

        <ng-container *ngFor="let field of [
          {key:'cpsoUndertaking43', title:'4408-01-789-02 Investment in Public Sector & Other Undertakings, (SOON) SOE-43'},
          {key:'cipacCoop43', title:'4425-00-789-01 Investment in Pry. Agriculture Credit Cooperative (SOON) SOE-43'},
          {key:'csciCoop43', title:'4851-00-789-01 Share Capital Investment in Indl. Coops. (SOON) SOE-43'},
          {key:'cNewSCMember', title:'2425-00-789-05-SOON SOE-63 Enrollment Subsidy To New SC Members'},
          {key:'cscCoop', title:'2425-00-789-06 -SOON SOE-63 Working Capital Subsidy To All Kinds of SC Coops.'}
        ]">

          <div class="col-lg-6">
            <div class="card">
              <div class="card-header">
                <h5 class="m-0">{{ field.title }}</h5>
              </div>
              <div class="card-body">
                <div class="row">

                  <div class="col-md-6 mb-2">
                    <label class="form-label m-0">Budget<sup class="text-danger">*</sup></label>
                    <input type="text" class="form-control" placeholder="Please Enter"
                      maxlength="10" (keypress)="onlyNumbers($event)"
                      formControlName="{{field.key}}Budget">
                    <div
                      *ngIf="expenditureForm.get(field.key + 'Budget')?.touched && expenditureForm.get(field.key + 'Budget')?.invalid"
                      class="text-danger small">
                      This field is required.
                    </div>
                  </div>

                  <div class="col-md-6 mb-2">
                    <label class="form-label m-0">Expenditure<sup class="text-danger">*</sup></label>
                    <input type="text" class="form-control" placeholder="Please Enter"
                      maxlength="10" (keypress)="onlyNumbers($event)"
                      formControlName="{{field.key}}Amount">
                    <div
                      *ngIf="expenditureForm.get(field.key + 'Amount')?.touched && expenditureForm.get(field.key + 'Amount')?.invalid"
                      class="text-danger small">
                      This field is required.
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>

        </ng-container>

        <!-- Circle Overall -->
        <div class="col-lg-6">
          <div class="card">
            <div class="card-header">
              <h5 class="m-0">Overall</h5>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-6 mb-2">
                  <label class="form-label m-0">Total Budget<sup class="text-danger">*</sup></label>
                  <input type="text" formControlName="cOverAllBudget" class="form-control"
                    placeholder="Please Enter" maxlength="10" (keypress)="onlyNumbers($event)">
                  <div
                    *ngIf="expenditureForm.get('cOverAllBudget')?.touched && expenditureForm.get('cOverAllBudget')?.invalid"
                    class="text-danger small">
                    This field is required.
                  </div>
                </div>

                <div class="col-md-6 mb-2">
                  <label class="form-label m-0">Total Expenditure<sup class="text-danger">*</sup></label>
                  <input type="text" formControlName="cOverAllAmount" class="form-control"
                    placeholder="Please Enter" maxlength="10" (keypress)="onlyNumbers($event)">
                  <div
                    *ngIf="expenditureForm.get('cOverAllAmount')?.touched && expenditureForm.get('cOverAllAmount')?.invalid"
                    class="text-danger small">
                    This field is required.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div class="col-lg-12 text-end mb-4" *ngIf="!isViewMode">
      <button type="submit" class="btn btn-primary">Save</button>
    </div>

  </div>
</form>


</div>